module.exports = [
  {
    title: 'Наименование',
    key: 'name'
  },
  {
    title: 'Услуга по умолчанию',
    key: 'service_text'
  }
]
